import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FillableForm from "./FillableForm";
import { PageLoader } from "@/_components";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { updateField } from "./FormHelpers";
import { GetTemplateFileByDescription } from "../../_api/documentsApi";
import { getProfile } from "../../_api/profileApi";
import { getCountyList } from "../../_api/usersApi";
import Cookies from "universal-cookie";

export default function PARestorationRequirementsLetter({
  handleClose,
  handleFormSaved,
  userID,
  clientID,
  jurisdictionID,
  reportID,
  vehicleID,
  appointmentID,
  formDescription,
}) {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const user = cookies.get("lifesaferUser");
  const [templateFile, setTemplateFile] = useState(null);
  const [client, setClient] = useState(null);
  const [counties, setCounties] = useState(null);

  useEffect(() => {
    if (!client) {
      // get clientProfile
      getProfile(clientID)
        .then((clientData) => {
          setClient(clientData[0]);
        })
        .catch((error) => {
          console.error("Error getting client data : ", error);
        });
    }
    if (!templateFile) {
      GetTemplateFileByDescription(user.languageID, "PA_RRL")
        .then((document) => {
          setTemplateFile(
            `data:application/pdf;base64,${document.fileBase64Value}`
          );
        })
        .catch((error) =>
          console.error("Error getting template file: ", error)
        );
    }
  }, []);

  useEffect(() => {
    if (client) {
      // get all counties in client's conviction state
      getCountyList(client.convStateRegionID)
        .then((countiesData) => {
          //console.log({ countiesData });
          setCounties(countiesData);
        })
        .catch((error) => {
          console.error("Error getting counties: ", error);
        });
    }
  }, [client]);

  return (
    <>
      {(!templateFile || !client || !counties) && (
        <Grid
          container
          direction="column"
          alignItems="center"
          sx={{ marginTop: 5, paddingTop: 5 }}
        >
          <PageLoader />
        </Grid>
      )}
      {templateFile && client && counties && (
        <FillableForm
          userID={userID}
          clientID={clientID}
          jurisdictionID={jurisdictionID}
          reportID={reportID}
          vehicleID={vehicleID}
          appointmentID={appointmentID}
          handleClose={handleClose}
          handleFormSaved={handleFormSaved}
          templateFile={templateFile}
          formName="PA_RRL.pdf"
          formDescription={formDescription}
          validationFunction={(viewer) => {
            // ssn numbers only
            let ssnIsValid = false;
            let ssnField = viewer.formFieldCollection.find(
              (f) => f.name === "SSN"
            );
            let isOnlyFour = ssnField.value.length === 4;
            let onlyNumbers = !isNaN(ssnField.value.trim());
            if (isOnlyFour && onlyNumbers) {
              ssnIsValid = true;
            } else {
              ssnIsValid = false;
            }

            // client signature
            let signatureIsValid = false;
            let signatureField = viewer.formFieldCollection.find(
              (f) => f.name === "ClientSignature"
            );
            let signatureIsComplete = signatureField.value !== "";
            if (signatureIsComplete) {
              signatureIsValid = true;
            } else {
              signatureIsValid = false;
            }

            if (ssnIsValid && signatureIsValid) {
              return true;
            } else {
              if (!ssnIsValid) {
                return t("documents.invalidSSN");
              } else {
                return false;
              }
            }
          }}
          fillingFunction={(data, viewer) => {
            for (let item in data) {
              let bIsReadOnly = false;
              if (item == "FirstName" || item == "LastName" || item == "Date") {
                bIsReadOnly = true;
              } else if (item == "ConvictionCounty") {
                let field = viewer.formFieldCollection.find(
                  (x) => x.name === item
                );
                var countiesOptions = counties.map((c) => {
                  return {
                    itemName: c.countyName,
                    itemValue: c.regionID.toString(),
                  };
                });
                viewer.formDesignerModule.updateFormField(field, {
                  isReadOnly: false,
                  options: countiesOptions,
                  value: client.convictionCounty,
                });
              }
              updateField(item, data[item], viewer, bIsReadOnly);
            }
          }}
          fillingData={{
            FirstName: client.firstName,
            LastName: client.lastName,
            ConvictionCounty: client.convictionCounty,
            Date: new Date().toLocaleDateString(),
            DOB: new Date(client.dob).toLocaleDateString(),
            DLNum: client.dlNum,
          }}
          setDefaultAppearence={false}
        />
      )}
    </>
  );
}

PARestorationRequirementsLetter.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleFormSaved: PropTypes.func.isRequired,
  userID: PropTypes.number.isRequired,
  clientID: PropTypes.number.isRequired,
  jurisdictionID: PropTypes.number.isRequired,
  reportID: PropTypes.number.isRequired,
  vehicleID: PropTypes.number.isRequired,
  appointmentID: PropTypes.number.isRequired,
  formDescription: PropTypes.string.isRequired,
};
